import {
    AdyenSessionDto,
    PaymentMethodDto,
    SurchargeQuoteDto
} from 'actions/paymentMethods/PaymentMethodsDtos';
import {
    AdyenSession,
    PaymentMethod,
    PaymentMethodBrand,
    SurchargeQuote
} from 'types/PaymentMethod';

const BRAND_ALIASES: Record<string, PaymentMethodBrand> = {
    'mc': 'mastercard',
    'mastercard': 'mastercard',
    'master card': 'mastercard',
    'mastercard_applepay': 'mastercard',
    'mastercard_googlepay': 'mastercard',
    'visa': 'visa',
    'visa_applepay': 'visa',
    'visa_googlepay': 'visa',
    'amex': 'amex',
    'american express': 'amex',
    'amex_applepay': 'amex',
    'amex_googlepay': 'amex',
    'discover': 'discover',
    'diners': 'diners',
    'diners club': 'diners'
};

const BRAND_LABELS: Record<PaymentMethodBrand, string> = {
    mastercard: 'MasterCard',
    visa: 'Visa',
    amex: 'American Express',
    discover: 'Discover',
    diners: 'Diners Club',
    unknown: 'Card'
};

const normalizeBrand = (raw: string | undefined): PaymentMethodBrand => {
    if (!raw) return 'unknown';
    const key = raw.trim().toLowerCase();
    return BRAND_ALIASES[key] ?? 'unknown';
};

export const dtoToPaymentMethod = (dto: PaymentMethodDto): PaymentMethod => {
    const brand = normalizeBrand(dto.brand);

    return {
        id: dto.id,
        uuid: dto.uuid,
        brand,
        brandName: BRAND_LABELS[brand],
        lastDigits: dto.last4,
        expirationMonth: dto.expiration_month,
        expirationYear: dto.expiration_year,
        primary: dto.primary,
        expired: dto.expired
    };
};

export const dtoToAdyenSession = (dto: AdyenSessionDto): AdyenSession => {
    return {
        id: dto.id,
        sessionData: dto.sessionData,
        countryCode: dto.countryCode,
        amount: dto.amount
    };
};

export const dtoToSurchargeQuote = (
    dto: SurchargeQuoteDto,
    paymentMethodId: number
): SurchargeQuote => {
    const toNumber = (v: number | string) => (typeof v === 'number' ? v : Number(v));

    // Backend returns `total_amount` (base + surcharge incl. tax) and
    // `total_surcharge_amount` (surcharge incl. tax). The base deposit is the
    // difference.
    const total = toNumber(dto.total_amount);
    const surcharge = toNumber(dto.total_surcharge_amount);

    return {
        paymentMethodId,
        amount: total - surcharge,
        surcharge,
        total
    };
};
